/**
 * تنزيل Blob كملف
 */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  console.log('💾 بدء عملية التنزيل...');
  console.log('📦 حجم الملف:', blob.size, 'bytes');
  console.log('📄 اسم الملف:', fileName);
  console.log('🏷️ نوع الملف:', blob.type);
  
  try {
    // التأكد من أن blob صالح
    if (!blob || blob.size === 0) {
      throw new Error('الملف فارغ أو غير صالح');
    }
    
    // إنشاء رابط تنزيل مباشر
    const url = URL.createObjectURL(blob);
    console.log('🔗 تم إنشاء رابط التنزيل:', url);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.style.display = 'none';
    
    console.log('➕ إضافة رابط التنزيل للصفحة...');
    document.body.appendChild(link);
    
    console.log('🖱️ تشغيل التنزيل...');
    link.click();
    
    console.log('🗑️ إزالة رابط التنزيل...');
    document.body.removeChild(link);
    
    // تنظيف الذاكرة
    setTimeout(() => {
      URL.revokeObjectURL(url);
      console.log('🧹 تم تنظيف الذاكرة');
    }, 1000);
    
    console.log('✅ تم التنزيل بنجاح!');
  } catch (downloadError) {
    console.error('❌ فشل في التنزيل:', downloadError);
    throw new Error('فشل في تنزيل الملف: ' + downloadError);
  }
};

/**
 * محاولة التنزيل بطرق متعددة (غير مستخدمة حالياً)
 */
const attemptAdvancedDownload = async (blob: Blob, fileName: string): Promise<boolean> => {
  try {
    // الطريقة الأولى: استخدام navigator.msSaveBlob للـ Internet Explorer
    if (typeof window !== 'undefined' && (window as any).navigator?.msSaveBlob) {
      (window as any).navigator.msSaveBlob(blob, fileName);
      console.log('✅ تم التنزيل باستخدام msSaveBlob');
      return true;
    }

    // الطريقة الثانية: استخدام showSaveFilePicker للمتصفحات الحديثة
    if (typeof window !== 'undefined' && 'showSaveFilePicker' in window) {
      try {
        const fileHandle = await (window as any).showSaveFilePicker({
          suggestedName: fileName,
          types: [{
            description: 'PDF files',
            accept: { 'application/pdf': ['.pdf'] }
          }]
        });
        
        const writable = await fileHandle.createWritable();
        await writable.write(blob);
        await writable.close();
        console.log('✅ تم التنزيل باستخدام File System Access API');
        return true;
      } catch (fsError) {
        console.log('ℹ️ File System Access API غير متاح أو تم إلغاؤه');
      }
    }

    return false; // لم تنجح أي طريقة
  } catch (error) {
    console.warn('⚠️ فشلت طرق التنزيل المتقدمة:', error);
    return false;
  }
};